export const TERMS_OF_SERVICE = {
    title: 'サービス利用規約',
    sections: [
        {
            heading: '第1条 (MAny利用規約の適用及び変更)',
            content: `1. MAnyサービス利用規約(以下「本規約」といいます。)は、株式会社Sirbe
(以下「当社」といいます。)が運営するインターネットサービス「MAny(メニー)」(以下「本サービス」といいます。)の利用者が遵守いただきたい事項及び利用者と当社との関係を定めるものです。本サービスの利用者は、本規約の内容を十分理解した上でその内容を遵守することに同意して本サービスを利用するものとし、本サービスを利用した場合には、当該利用者は本規約を遵守することに同意したものとみなします。
2. 当社は、当社の裁量で本規約を必要に応じ変更・追加・削除できるものとします。また、本規約を変更した場合には、当社は本サービス上に掲載するものとし、変更後、本サービスを利用した場合には、変更された利用規約の内容に同意したものとみなします。`,
        },
        {
            heading: '第2条 (定義)',
            content: `1. 「本サービス」とは、当社が「MAny(メニー)」の名称で運営するサービスをいいます。
2. 「会員」とは、本サービスにて会員登録したM&A検討企業をいいます。
3. 「アドバイザー」とは、利用者のうち、本サービスで所定の利用者登録手続きを行い、当社から登録の承諾を受けた個人または法人をいいます。
4. 「利用者」とは、本サービスの申込者であり、かつ本規約を遵守することを条件に、本サービスの利用を運営者から許諾された者をいいます。
5. 「マッチング」とは、M&A検討企業がアドバイザーからのオファーを承諾し、当該利用者に対して情報開示およびチャット機能が有効化された状態をいいます。
6. 「オファー」とは、利用者が匿名投稿に対して自社の支援提案等を送信する行為をいいます。
7. 「情報開示」とは、M&A検討企業が利用者に対し、社名・連絡先・事業内容等の情報を開示することをいいます。
8. 「メッセージ」とは、チャット機能が有効化され、会員とアドバイザー間のメッセージのやり取りをいいます。`,
        },
        {
            heading: '第3条 (サービスの流れ)',
            content: `1. 会員は匿名で相談投稿を行います。
2. アドバイザーは、公開された匿名案件情報に対してオファーを送信することができます。
3. 会員がアドバイザーのオファーを承諾した場合、情報開示およびチャットが開設され、これをもってマッチングの成立とみなします。
4. マッチング成立により、アドバイザーに対してマッチング課金が発生します。`,
        },
        {
            heading: '第4条 (利用者登録)',
            content: `1. 利用者登録は利用者となる法人に限るものとします。
2. 利用者登録は法人名で登録し、入力した情報は全て真実であることを保証するものとします。
3. 当社は、以下の各号のいずれかの事由に該当する場合、事由を通知することなく会員登録を承認しないことがあります。
(1) 過去に本規約違反等により、当社から利用停止等の処分を受けている場合。
(2) 登録情報に正確ではない情報、又は虚偽の情報が含まれている場合。
(3) 反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下本条において同じとします。）である、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合。
(4) 未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人､保佐人又は補助人の同意等を得ていなかった場合。
(5) その他、当社が不適当であると判断した場合。`,
        },
        {
            heading: '第5条 (登録情報の変更)',
            content: `会員は、登録情報に変更がある場合には、直ちに最新の情報に登録内容を変更しなければならないものとします。`,
        },
        {
            heading: '第6条 (本サービスの利用)',
            content: `本サービスは、代理人による利用は認められないものとします。`,
        },
        {
            heading: '第7条 (本サービスの内容)',
            content: `1. 当社は、本サービスによる情報提供を通じて、アドバイザーが会員へのオファーを行い、会員とマッチングできるサービスです。会員は複数のアドバイザーとチャット開通・面談することにより、事業承継に係るトラブルの防止や正しい企業価値の評価を行うことができます。
MAnyでは、会員とアドバイザーとの正しい事業承継の場を提供するため、匿名相談投稿、オファー、承諾による情報開示およびチャット機能ツール及びプラットフォームの提供を行います。
2. 本サービスは、アドバイザーと会員を繋ぐということを目的としており、会員が複数のアドバイザーとの間で、メッセージを通じて、事業承継のセカンドオピニオンを実施させるためのツール等としてご利用いただけます。本サービスにおいては、事業承継を目的としない会社の紹介・あっせんを行うことはできません。`,
        },
        {
            heading: '第8条（評価・レビュー）',
            content: `1. アドバイザー会員は、本サービス上で別途提示するところにより、相互にレビュー及び評価を行うことができます。
一切のレビュー及び評価はアドバイザーまたは会員の意見を反映しており、当社の意見を反映したものではありません。
レビュー及び評価は、当社によりその正確さを検証されたものではなく、不正確又は誤解を招くものである可能性があります。
2. レビュー及び評価は、攻撃的又は中傷的な表現を含んではなりません。
3. アドバイザー及び会員は、他の利用者に関し好意的又は否定的なレビューや評価を依頼・指示する等、レビュー及び評価を操作してはなりません。
4. 当社は、前各項に違反するレビュー又は評価を発見した場合、投稿した利用者に対して修正を要求し、又は自ら修正や削除をすることができるものとします。
5. アドバイザー及び会員に対する否定的な評価があった場合においても、誹謗中傷等の悪質な場合を除き、当社はアドバイザー又は会員からの削除・編集等の依頼には応じません。`,
        },
        {
            heading: '第9条 (プレミアムオファー)',
            content: `1. 当社は、本サービス上で別途提示する条件により、アドバイザーに対し、プレミアムオファーを付与するものとします。
2. アドバイザーは、本サービス上で別途提示する条件において、プレミアムオファーをかけることで、より会員に対して優先的にアプローチが可能となります。
3. プレミアムオファーは、面談の確約、チャットの開通を保証するものではありません。会員によりお断りをされる場合がございます。
4. プレミアムオファーにおいて、会員にお断りされた場合でも別途提示する料金については返金しないものとします。
5. 当社は、前項に定めるプレミアムオファーの執行によりアドバイザー又は会員に不利益又は損害が生じた場合であっても、一切の責任を負わないものとします。`,
        },
        {
            heading: '第10条（専門士業の独占業務について）',
            content: `当社は、M&Aに関する情報提供およびマッチングの場を提供するものであり、弁護士法、税理士法、司法書士法、社会保険労務士法、弁理士法その他関連法令により各士業に独占的に認められた業務を行うものではありません。
仲介会社その他の利用者は、当サービスの利用に際して、非弁行為、非税理士行為、その他の非資格者行為に該当しないよう十分にご留意ください。必要に応じ、弁護士・税理士等の専門資格者へご相談ください。`,
        },
        {
            heading: '第11条 (個人情報の取り扱い)',
            content: `当社は利用者情報を当社の別途定めるプライバシーポリシーに基づき、適切に取り扱うものとします。`,
        },
        {
            heading: '第12条 (利用者の守秘義務等)',
            content: `1. 会員は、本サービスで成立したチャットの開通においてアドバイザーより入手した情報を、秘密情報として現に秘密を保持し、事前に情報を提供した者の書面の同意がない限り、当該面談以外の目的で使用することができず、第三者に開示又は漏洩をしてはならないものとします。
2. 会員は、前項で定める情報を複製してはならないものとします。
3. アドバイザーとの面談において生じた、アドバイザーの条件及びサービスに関する事業譲渡の条件やアイデアは、アドバイザーに帰属する秘密情報とし、一切の権利はアドバイザーに帰属するものとします。
4. アドバイザーは、本サービスで成立したチャットの開通において会員より入手した情報を、秘密情報として現に秘密を保持し、事前に情報を提供した者の書面の同意がない限り、当該面談以外の目的で使用することができず、第三者に開示又は漏洩をしてはならないものとします。
5. アドバイザーは、前項で定める情報を複製してはならないものとします。
6. 本条に基づく義務は、本契約の終了後も存続するものとします。`,
        },
        {
            heading: '第13条 (禁止事項)',
            content: `1. 本サービスの利用者は、本サービスの利用に際して以下に記載する行為を行ってはならず、また以下の記載事項を行なわないことを保証するものとします。
(1) 当社又は第三者の権利(著作権、商標権、特許権等の知的財産権、名誉権、プライバシー権、その他法令上又は契約上の権利を広く含みます。)を害する行為。
(2) 企業機密等の情報を漏洩するなど、守秘義務に違反する行為。
(3) 所属企業、団体等の内部規則等に違反する行為。
(4) 虚偽の情報を故意に登録・投稿する行為。
(5) 自己のアカウントを他人に利用させる、アカウントを共同利用するなどのアカウントを不正に利用する行為や、第三者に成りすます行為。
(6) 当社の承諾を得る事無く、本サービス経由で成立したアポイントメントに関する権利を他人に譲渡する行為。
(7) 本サービスを介して知り合ったにも関わらずシステム利用料等を支払わずに紹介を受ける行為。
(8) 本サービスで紹介者の人脈等を知ったにも関わらず、サイト外で連絡を取り合い、当社を排除した紹介に係る契約等を締結し、当社の提供する決済システム利用を回避するなどして当社への利用料の支払を回避する行為。
(9) 当社の業務に支障を与える行為。
(10) ウイルスの送付、不正アクセス等により、当社システム及び本サービス提供に障害等を引き起こす行為。
(11) その他本サービス、当社の業務を妨害、又は当社の信頼を毀損する行為。
(12) 宗教活動又は宗教団体や、ネットワークビジネス、マルチ商法、ねずみ講などへのへの勧誘行為。
(13) 異性との出会いを目的とする行為。
(14) 本サービスを利用したアフィリエイト誘導、目的に合致しないリンクの貼付け行為。
(15) 法令、公序良俗に反する行為、そのおそれがある行為。
(16) 本規約又は本サービスの趣旨又は目的に反する行為。
(17) 本サービス、当社又は利用者の情報を収集する行為。
(18) 本サービスに使用するソフトウェア又はシステムの誤作動を誘引する行為、本サービスの運営妨害行為。
(19) 本サービスに使用するソフトウェアの逆アセンブル、逆コンパイル、リバースエンジニアリング、その他当該ソフトウェアのソースコードを解析する行為。
(20) 本サービスに使用するシステムに権限なく不正にアクセスし、又は当社設備に蓄積された情報を不正に書き換え・消去する行為。
(21) ウィルス等の有害なコンピュータプログラムが実行される、又は実行されるおそれのあるコードを送信する行為。
(22) 当社・本サービスに対する誹謗中傷、嫌がらせの書き込み、その他本サービスの健全な運営を妨げる行為。
(23) その他当社が不適切であると判断する行為。
2. 前項第6号又は第7号に該当する行為を行った会員は、本サービス上で別途定めるところにより、当社に対し賠償金を支払うこととし、会員はあらかじめこれを承諾することとします。`,
        },
        {
            heading: '第14条（規約違反等に対する措置）',
            content: `1. 当社は、利用者が次の各号の一に該当し、又は該当するおそれがある場合には、何らの通知又は催告を行うことなく、本サービスの利用の一時停止若しくは制限又は本契約の解除その他の措置を講じることができる。
(1) 本規約のいずれかの条項に違反した場合
(2) 登録事項に虚偽の事実があることが判明した場合
(3) ６ヶ月以上本サービスの利用がない場合
(4) 当社からの問合せその他の回答を求める連絡に対し３０日間以上応答がない場合
(5) 本サービスの運営又は保守管理上必要であると当社が判断した場合
(6) 会員が死亡した場合又は後見開始、保佐開始若しくは補助開始の審判を受けた場合
(7) 支払不能、支払停止となり、又は破産手続開始、民事再生手続開始、会社更生手続、特別清算若しくはこれらに類する手続の開始の申立てがあった場合
(8) 手形又は小切手の不渡りの処分があった場合
(9) 手形交換所の取引停止処分があった場合
(10) 仮差押え、仮処分、強制執行若しくは競売の申立てがあった場合又は公租公課の滞納処分があった場合
(11) 重大な財務状態の悪化又は信用の低下が認められる場合
(12) その他前各号に準じ、又はこれに類する事由がある場合
2. 当社は、本条第１項の措置により会員に生じた不利益及び損害について一切の責任を負わないものとする。
3. 会員は、本規約のいずれかの条項に違反した場合、当社に対し当該違反により当社に生じた損害の賠償をするものとします。`,
        },
        {
            heading: '第15条 (サービスの中断、停止、終了)',
            content: `1. 当社は、以下の各号いずれかに該当する場合には、利用者に通知することなく、本サービスの全部又は一部の提供を停止又は中断することができるものとします。
(1) 本サービスに係るコンピューターシステムの点検又は保守作業を緊急に行う場合。
(2) コンピューター、通信回線等が事故により停止した場合。
(3) 地雷、落雷、火災、風水害、停電、天変地異などの不可抗力により本サービスの運営ができなくなった場合。
(4) その他当社が停止又は中断を必要と判断した場合。
2. 当社は、本サービスの一部又は全部をいつでも終了できる権利を有する。
3. 当社は、本サービスの一部又は全部を終了する場合、廃止する１か月以上前に会員に対して通知を行う
4. 当社が予期し得ない事由又は法令・規則の制定・改廃、天災等の止む得ない事由で、本サービスを終了する場合において１か月以上前の通知が不能なときでも、当社は可能な限り速やかに会員に対して通知をする。
5. 当社は、本条に基づいて当社が行った措置によって会員及び利用者に生じた損害について、責任を負わないものとします。`,
        },
        {
            heading: '第16条 (非保証)',
            content: `1. 本サービスにて、アドバイザー及びM&A検討企業が発信又は掲載したコンテンツに関する一切の責任は、当該会員が負うものとし、当社は、その内容、正確性、適法性等について、確認しないものとします。また、それらに関して一切保証、責任を負わないものとします。
2. 当社は、本サービスに関連するコンテンツの中に、コンピュータウィルス等の有害なものが含まれていないことに関し、保証しないものとします。また、本サービスに関連するコンテンツの中に、コンピュータウィルス等有害なものが含まれていたことにより生じた損害について、利用者及び第三者に対して当社は責任を負わないものとします。
3. 当社は、本サービスに瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証するものではなく、現状有姿のまま提供するものとします。`,
        },
        {
            heading: '第17条 (免責事項)',
            content: `1. 当社は、以下の各号の事項に伴い発生した損害等について、理由の如何を問わず、責任を負わないものとします。
(1) 本サービスを通じて、利用者間、又は利用者と第三者の間でトラブルが発生した場合。
(2) 本サービスからリンクされた当社以外のウェブサイトの利用に伴うトラブルが発生した場合。
(3) 本サービスの登録・投稿等のデータが消失した場合。
(4) 本サービス、当社システムへの不正アクセス、コンピューターウイルスの混入等が発生した場合。
(5) 当社から送付されるメール、本サービスにコンピューターウイルス等有害なものが含まれていた場合。
(6) 本サービスが中断、停止、終了した場合。
(7) 規約に基づく利用停止等の対応により、当該会員が損害を被った場合。
2. 本規約のうち消費者契約法の消費者契約に該当する事項には、当社の損害賠償責任を完全に免責する前項の規定は適用されないものとします。会員に発生した損害が当社の債務不履行又は不法行為に基づき、かつ当社に故意又は重過失がある場合においては、当社は、当該会員が直接被った通常損害を上限として損害賠償責任を負うものとします。`,
        },
        {
            heading: '第18条 (権利帰属)',
            content: `1. 本サービスに関連するすべてのコンテンツの知的財産権、著作権は、全て当社又は当該権利を有する権利者に帰属するものとします。
2. 会員により、本サービスに投稿されたすべての写真・情報等に関しては、本サービスの宣伝、運営等を目的として、当社が自由に利用できるものとします。
3. 本サービスの全ての情報について、当社以外が、当社に無断でこれを利用、転用することはできません。`,
        },
        {
            heading: '第19条 (アカウント情報の管理等)',
            content: `1. 利用者はアカウント情報を自ら管理する責任を負います。利用者は、アカウント情報を第三者等に利用させたり、譲渡や売買、質入、貸与、賃貸したり、その他形態を問わず処分することはできません。
2. アカウント情報の管理不十分による情報の漏洩、使用上の過誤、第三者の使用、不正アクセス等による損害の責任は会員が負うものとし、当社は一切責任を負わないものとします。また、アカウント情報が不正に利用されたことにより当社に損害が生じた場合、利用者は当該損害を賠償するものとします。
3. アカウント情報が第三者に漏えいした場合又はそのおそれがある場合、速やかに当社まで連絡するものとします。また、その際に当社の指示がある場合にはこれに従うものとします。`,
        },
        {
            heading: '第20条 (反社会的勢力の排除)',
            content: `1. 当社及び利用者は、相手方が反社会的勢力（暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団、その他これらに準ずる者をいい、以下本条において同じとします。）に該当し、又は、反社会的勢力と以下の各号の一にでも該当する関係を有することが判明した場合には、何らの催告を要せず、本契約を解除することができるものとします。
(1) 反社会的勢力が経営を支配していると認められるとき
(2) 反社会的勢力が経営に実質的に関与していると認められるとき
(3) 自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、不当に反社会的勢力を利用したと認められるとき
(4) 反社会的勢力に対して資金等を提供し、又は便宜を供与するなどの関与をしていると認められるとき
(5) その他役員等又は経営に実質的に関与している者が、反社会的勢力と社会的に非難されるべき関係を有しているとき
2. 当社及び利用者は、相手方が自ら又は第三者を利用して以下の各号の一にでも該当する行為をした場合には、何らの催告を要せず、本契約を解除することができるものとします。
(1) 暴力的な要求行為
(2) 法的な責任を超えた不当な要求行為
(3) 取引に関して、脅迫的な言動をし、又は暴力を用いる行為
(4) 風説を流布し、偽計又は威力を用いて信用を毀損し、又は業務を妨害する行為
(5) その他前各号に準ずる行為
3. 当社及び利用者は、自己又は自己の下請又は再委託先業者（下請又は再委託契約が数次にわたるときには、そのすべてを含むむのとし、以下同じとします。）が第1項に該当しないことを確約し、将来も同項若しくは前項各号に該当しないことを確約するものとします。
4. 当社及び利用者は、その下請又は再委託先業者が前項に該当することが契約後に判明した場合には、ただちに当該契約を解除し、又は契約解除のための措置をとらなければならないものとします。
5. 当社及び利用者は、自己又は自己の下請若しくは再委託先業者が、反社会的勢力から不当要求又は業務妨害等の不当介入を受けた場合は、これを拒否し、又は下請若しくは再委託先業者をしてこれを拒否させるとともに、不当介入があった時点で、速やかに不当介入の事実を相手方に報告し、相手方の捜査機関への通報及び報告に必要な協力を行うものとします。
6. 当社又は利用者が本条第3項から前項のいずれかの規定に違反した場合、相手方は何らの催告を要さずに、本契約を解除することができるものとします。
7. 当社又は利用者が前各項の規定により本契約を解除した場合には、相手方に損害が生じても何らこれを賠償ないし補償することは要せず、また、かかる解除により自己に損害が生じたときは、相手方はその損害を賠償するものとします。`,
        },
        {
            heading: '第21条 (規約の変更)',
            content: `1. 当社は、法律で定められた範囲において、2週間前に通知をすることで、本規約の内容を変更又は追加できるものとします。ただし、利用者の不利益にならない場合又は緊急やむを得ない場合は、事前の通知をすることなく、本規約の内容を変更又は追加できるものとします。
2. 変更後の本規約は、当社が別途定める場合を除いて、本サービス内又は当社ウェブサイトに掲示された時点より、その効力を生じるものとします。
3. 利用者は、本規約の変更に同意しない場合には、直ちに本サービスの利用及び閲覧を停止するものとします。利用者が本規約の変更の効力発生後、当社からの承諾を求める通知について一定期間返答をしないまま本サービスの利用を継続する場合、当該利用者は、変更後の本規約に同意したものとみなされるものとします。`,
        },
        {
            heading: '第22条 (不可抗力)',
            content: `地震、台風、津波その他の天変地異、戦争、暴動、内乱、テロ行為、疫病、法令・規則の制定・改廃、公権力による命令・処分その他の政府による行為、争議行為、輸送機関・通信回線等の事故、その他不可抗力による契約の全部又は一部の履行遅滞又は履行不能については、当社は何ら責任を負わないものとします。`,
        },
        {
            heading: '第23条 (通知・連絡)',
            content: `当社は、本サービスに関する当社から利用者の通知・連絡を、利用者が当社に登録した電子メールアドレス、住所又は電話番号に対し、メッセージング機能、電子メール、郵便又は電話等を用いて通知又は連絡を行います。当社からの通知及び連絡が不着であったり遅延したりといったことによって生じる損害について、当社は一切の責任を負わないものとします。`,
        },
        {
            heading: '第24条 (権利義務の譲渡等)',
            content: `1. 利用者は、当社の書面による事前の承諾がなければ、本規約に基づく自己の権利又は義務を第三者に対して譲渡若しくは承継させ、又は担保に供することができない。
2. 当社は、株式譲渡若しくは事業譲渡又は合併、会社分割その他の組織再編が生じた場合、利用者の同意を得ることなく、本規約に基づく自己の義務を第三者に対して譲渡若しくは承継させることができるものとします。`,
        },
        {
            heading: '第25条 (準拠法・裁判管轄)',
            content: `本規約は、日本法に基づき解釈されるものとします。利用者と当社の間で生じた一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。`,
        },
    ],
};

export const TERMS_OF_SERVICE_FOR_SUPPORTER = {
    title: 'サポーター利用規約',
    sections: [
        {
            heading: '第 1 条(目的)',
            content: `本規約は、MAny サポーターの登録条件、活動内容、当社との関係、権利義務等を定めることにより、事業承継に悩む経営者の「納得できる意思決定」を支えることを目的とします。`,
        },
        {
            heading: '第 2 条(定義)',
            content: `本規約における用語の定義は、以下のとおりとします。
1.「MAny」とは、当社が開発・運営する、事業承継を検討する経営者と M&A 等の知見を有する専門家とのマッチングプラットフォームをいいます。
2.「サポーター」とは、本規約に同意のうえ、当社所定の方法により申込みを行い、当社が MAny サポーターとしての登録を承認した者をいいます。
3.「MAny ユーザー」とは、当社所定の方法により MAny に登録し、利用契約を締結した経営者その他の利用者をいいます。
4.「本活動」とは、本規約に基づきサポーターとして、MAny ユーザーおよび地域等に対して行う、事業承継・M&A に関する情報提供、相談対応、イベント・勉強会等の企画・運営その他当社が認める一切の活動をいいます。
5.「登録情報」とは、サポーター登録にあたり当社所定のフォーム等を通じてサポーターが当社に提供する氏名、連絡先、経歴その他一切の情報をいいます。
6.「投稿情報」とは、サポーターが本活動に関連して、当社の運営するウェブサイト、コミュニティページ(オンラインコミュニティ、SNS グループ等を含みます。)その他当社所定の媒体に掲載・投稿する文章、画像、動画その他一切の情報をいいます。
7.「MAny ロゴ」とは、当社がサポーターに対し、本規約および当社が別途定めるガイドラインに従って利用を認めるロゴ等の画像データおよび表記をいいます。
8.「法令等」とは、法令、政省令、条例、通達、指針、ガイドラインその他これらに準ずる公的規制をいいます。`,
        },
        {
            heading: '第 3 条(MAny サポーターについて)',
            content: `1.サポーターとは、本規約に同意し、当社所定の登録フォームに登録情報を入力・送信のうえ、当社が審査の結果、登録を承認した者をいいます。
2.サポーターとして活動することを希望する者は、当社の指定する方法により申込みを行うものとします。当社は、申込みを受領後、経歴・活動内容・価値観等を確認のうえ、サポーターとして適切と判断した場合に限り登録を承認し、本契約(本活動に関する契約)が成立するものとします。
3.当社は、自己の裁量により申込みを承諾しないことができるものとし、その理由を開示する義務を負わないものとします。
4.サポーターは、当社または MAny ユーザーとの間で、雇用契約、委任契約その他いかなる法的代理関係・共同事業関係も当然には成立するものではなく、独立した立場で本活動を行うものとします。
5.当社は、サポーターに対し、本活動に関連して、専用ページへの掲載、情報提供、イベントへの案内その他当社が必要と認める各種サービスを提供することができるものとします。具体的な内容は、当社が別途定めるものとします。`,
        },
        {
            heading: '第 4 条(登録情報の管理)',
            content: `1.サポーターは、登録情報を自己の責任において適切に管理しなければならないものとします。
2.サポーターは、登録情報を第三者に貸与、譲渡、売買、名義変更、担保提供等してはならず、第三者に利用させてはならないものとします。
3.登録情報の漏洩、不正利用、なりすまし等が発生し、またはそのおそれがあることを知った場合、サポーターは直ちに当社に通知し、当社の指示に従うものとします。
4.登録情報の管理不備によりサポーターまたは第三者に損害が生じた場合であっても、当社は当社に故意または重過失がある場合を除き、一切の責任を負わないものとします。`,
        },
        {
            heading: '第 5 条(登録情報の変更)',
            content: `サポーターは、氏名、所属、連絡先その他登録情報に変更が生じた場合、当社所定の方法により遅滞なく当該変更手続を行うものとします。登録情報の変更が行われなかったことにより、当社からの通知等が受領できなかった場合であっても、当社は一切の責任を負わないものとします。`,
        },
        {
            heading: '第 6 条(専用ページおよびコミュニティの利用)',
            content: `1.サポーターは、当社が運営する専用ページ、オンラインコミュニティ、SNS グループその他当社所定の媒体(以下「サポーター専用ページ等」といいます。)において、自身のプロフィール、本活動に関連するセミナー・イベント情報その他当社が認める掲載情報を投稿することができます。
2.サポーターは、サポーター専用ページ等に投稿する情報について、その内容の正確性、適法性および第三者の権利侵害がないことを保証し、自己の責任において行うものとします。
3.サポーターは、サポーター専用ページ等の利用に必要な通信機器、ソフトウェア、通信回線その他一切の環境を自己の費用と責任で準備・維持するものとします。
4.サポーターは、当社からサポーター専用ページ等に関して資料・情報等の提供その他の対応を求められた場合、誠実にこれに応じるものとします。
5.当社は、サポーター専用ページ等に投稿された情報が、本規約または当社の趣旨に反すると判断した場合、事前の通知なく当該情報を非公開・削除することができるものとします。`,
        },
        {
            heading: '第 7 条(謝礼・費用負担)',
            content: `1.本活動に対する謝礼の有無・内容・支払方法等は、当社が別途定める条件または当社とサポーターとの個別合意に従うものとします。
2.前項に定める場合を除き、サポーターは、本活動に伴い自己に発生する交通費、通信費、設備費その他一切の費用を自己の負担により賄うものとします。
3.本活動に係る謝礼の支払が行われる場合であっても、当社およびサポーターの間に雇用関係、労働契約その他これに類する関係が生じるものではありません。`,
        },
        {
            heading: '第 8 条(MAny ロゴ等の利用)',
            content: `1.サポーターは、本活動を行う目的に限り、当社が別途定めるガイドラインに従って MAnyロゴ等を利用することができます。
2.当社は、MAny ロゴの画像データ等について、サポーターに対し非独占的かつ譲渡不能な利用権を付与します。具体的なロゴ等の内容は、当社が裁量により決定するものとします。
3.サポーターは、当社の事前の書面による承諾なく、MAny ロゴの改変、加工、第三者への再許諾等を行ってはならないものとします。
4.サポーターは、自己の提供する商品・役務や活動について、当社が公式に認定または後援しているかのような表示(「公式」「オフィシャル」等)を行ってはならないものとします。ただし、当社が別途明示的に承諾した場合はこの限りではありません。
5.当社がサポーターに対し MAny ロゴの利用停止を求めた場合、サポーターは本活動の継続・終了にかかわらず、直ちに利用を中止するものとします。`,
        },
        {
            heading: '第 9 条(第三者サービスの利用)',
            content: `1.当社は、サポーター専用ページ等に関して、当社以外の第三者が提供するサービス(SNS、オンライン会議システム等。以下「第三者サービス」といいます。)と連携する場合がありますが、その継続性・機能等を保証するものではありません。
2.サポーターは、自己の責任と費用において第三者サービスを利用するものとし、当該利用によりサポーターに損害が生じた場合であっても、当社は一切の責任を負わないものとします。
3.サポーターは、第三者サービスの利用に際し、当該サービス提供者が定める利用規約その他の条件を遵守するものとします。`,
        },
        {
            heading: '第 10 条(個人情報の取扱い)',
            content: `当社がサポーターから取得した個人情報は、個人情報の保護に関する法律その他の法令等に従い、当社の定めるプライバシーポリシーに基づき取り扱うものとします。当社は、本活動の運営、MAny および関連サービスの提供・改善・開発等に必要な範囲内でサポーターの個人情報を利用することができるものとします。`,
        },
        {
            heading: '第 11 条(禁止事項)',
            content: `サポーターは、本活動に関連して、以下の各号に該当する行為を行ってはならないものとします。
1.当社、MAny ユーザー、他のサポーターその他第三者の権利・利益・名誉・信用・プライバシー等を侵害し、またはそのおそれのある行為
2.虚偽の情報、不正確な情報、誤解を招く情報の提供
3.法令等、または公序良俗に反する行為
4.本活動を通じた、マルチ商法、ネットワークビジネス、投機的商品等への勧誘行為
5.特定の宗教、政治活動、思想団体等への勧誘行為
6.MAny ユーザーまたは他のサポーターを対象とした過度な営業・勧誘行為、迷惑行為
7.当社の事前の承諾なく、MAny サポーターまたは MAny の名称・ロゴ等を用いてセミナー・イベント等を「公式」「公認」等と表示する行為
8.MAny ユーザーの個人情報その他機微情報を、本人の同意なく第三者に提供し、または本活動の目的外に利用する行為
9.反社会的勢力(第 16 条に定義)との関係を隠蔽し、またはこれに利益を供与する行為
10.MAny と同種または類似のサービスを、自らまたは第三者とともに立ち上げ、もしくはその準備を行うなど、当社の事業と競合する行為(当社が別途承諾した場合を除きます。)
11.MAny ユーザーに対し、当社の提供するサービスを早期に解約させ、または当社との関係を不当に悪化させることを目的として行う行為
12.本規約その他当社が別途定めるガイドライン等に違反する行為
13.その他、当社が不適切と合理的に判断する行為当社は、サポーターが前各号のいずれかに該当すると判断した場合、事前の通知なく、サポーターの登録情報・投稿情報等の削除、本活動の停止、サポーター資格の取消しその他必要な措置を行うことができるものとします。`,
        },
        {
            heading: '第 12 条(知的財産権)',
            content: `1.MAny および当社が提供するサービス、システム、ロゴ、デザイン、文書その他のコンテンツに関する著作権その他一切の知的財産権は、当社または正当な権利者に帰属します。
2.サポーターが本活動に関連して作成または投稿した投稿情報に関する著作権その他の権利は、原則として当該サポーターに帰属します。ただし、当社は、本活動および当社のサービスの紹介・広報・改善等の目的の範囲内で、当該投稿情報を無償かつ非独占的に利用(複製、公衆送信、翻案等を含みます。)することができるものとし、サポーターはあらかじめこれに同意します。
3.サポーターは、前項に基づく当社の利用に関し、当社および当社の指定する第三者に対して、著作者人格権を行使しないものとします。`,
        },
        {
            heading: '第 13 条(損害賠償)',
            content: `1.サポーターが本規約に違反し、または違法・不正な行為により当社に損害を与えた場合、サポーターは当社が被った一切の損害(合理的な弁護士費用を含みます。)を賠償する責任を負うものとします。
2.本規約に関連して当社がサポーターに対して損害賠償責任を負う場合、当社の故意または重過失による場合を除き、当社の責任は、サポーターが当社から受領した過去 3 ヶ月間の謝礼の総額を上限とします。`,
        },
        {
            heading: '第 14 条(退会)',
            content: `1.サポーターは、当社所定の方法により退会の申請を行うことができ、当社がこれを承認した時点で、本契約は終了するものとします。
2.サポーターが死亡した場合または法人その他団体であるサポーターが解散した場合、当該時点をもってサポーターとしての資格は当然に終了するものとします。
3.社会通念上、本活動の継続が困難であると当社が合理的に判断した場合、当社はサポーターに通知のうえ、本契約を終了させることができるものとします。`,
        },
        {
            heading: '第 15 条(規約違反の場合の措置)',
            content: `1.当社は、サポーターが本規約に違反し、または違反のおそれがあると合理的に判断した場合、サポーターに対して、以下のいずれかまたは複数の措置を講じることができます。
    1.事実確認および是正の要請
    2.サポーター専用ページ等へのアクセス制限
    3.投稿情報等の削除・非公開
    4.本活動の一時停止
    5.サポーター資格の取消し、本契約の解除
2.前項の措置によりサポーターに損害が生じた場合であっても、当社に故意または重過失がある場合を除き、当社は一切の責任を負わないものとします。`,
        },
        {
            heading: '第 16 条(反社会的勢力の排除)',
            content: `1.サポーターは、自己またはその役員等が、暴力団、暴力団員、暴力団関係企業・団体、総会屋、社会運動標榜ゴロ、特殊知能暴力集団その他これらに準ずる反社会的勢力(以下総称して「反社会的勢力」といいます。)に該当しないこと、過去にも該当したことがないこと、ならびに反社会的勢力と密接な関係を有していないことを表明し、保証します。
2.サポーターは、将来にわたって反社会的勢力に該当せず、また反社会的勢力と関係を有しないことを保証します。
3.当社は、サポーターが前各項のいずれかに違反していると合理的に判断した場合、何らの催告を要せず、直ちに本契約を解除し、サポーター資格を取消すことができるものとします。`,
        },
        {
            heading: '第 17 条(秘密保持)',
            content: `サポーターは、本活動に関連して知り得た当社および MAny ユーザーその他第三者の業務上・技術上・個人に関する一切の情報(公開されていないものに限ります。以下「秘密情報」といいます。)を、当社の事前の書面による承諾なく、本活動の目的以外に利用し、または第三者に開示・漏洩してはならないものとします。本契約終了後も本条の義務は存続します。`,
        },
        {
            heading: '第 18 条(本規約の変更)',
            content: `1.当社は、必要と判断した場合、本規約を変更することができるものとします。
2.当社は、本規約を変更する場合、変更後の規約の内容および効力発生日を、当社ウェブサイトへの掲示その他当社所定の方法により周知します。
3.効力発生日以降にサポーターが本活動を継続した場合、サポーターは変更後の本規約に同意したものとみなします。`,
        },
        {
            heading: '第 19 条(準拠法・合意管轄)',
            content: `1.本規約の成立、効力、履行および解釈については、日本法を準拠法とします。
2.本規約に関連して当社とサポーターとの間に生じた一切の紛争については、当社本店所在地を管轄する地方裁判所をもって第一審の専属的合意管轄裁判所とします。`,
        },
    ],
};
